import { Breadcrumbs, Chip, Link, Stack } from "@mui/material";
import HerbImage from "../../assets/doors/19_tfgi.jpeg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { SiteRoutes } from "../../PageRouter";

export const Door19 = () => {
  const ingredients = [
    "Karotten",
    "Pastinaken",
    "Porre",
    "Sellerie",
    "Petersilie",
    "Kerbel",
  ];

  const doorNr = 19;

  const shortDecription = "Ein altes Huhn gibt eine gute Suppe.";

  const herbName = "Suppen Kräuter";

  const recepieExample = (
    <div>
      <h4>Kartoffel-Möhren-Suppe</h4>
      Je 125g Kartoffeln und Karotten schälen, würfeln und eine viertel Zwiebel
      hacken. Zusammen mit dem gesammten Inhalt des Gewürzfläschens und 1 EL
      Kräutersalz in 250ml Wasser, 30 Minuten köcheln. 150g Kräuterfrischkäse
      einrühren und pürieren. Mit Salz und Pfeffer abschmecken.
    </div>
  );

  const breadcrumb = (
    <Breadcrumbs maxItems={4} separator={<NavigateNextIcon fontSize="small" />}>
      <Link
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="inherit"
        href="/"
      >
        Start
      </Link>
      {SiteRoutes.map((route) => {
        if (route.doorNumber && route.doorNumber <= doorNr) {
          return (
            <Link
              key={route.path}
              underline="hover"
              color="inherit"
              href={route.path}
            >
              Tag {route.doorNumber}
            </Link>
          );
        } else {
          return undefined;
        }
      })}
    </Breadcrumbs>
  );

  return (
    <>
      <img src={HerbImage} className="herb_img" alt="herb" />
      {breadcrumb}
      <h1 className="herb_name">{herbName}</h1>
      <i>{shortDecription}</i>
      <h3 className="content">Inhalt</h3>
      <div>
        <Stack
          spacing={1}
          direction="row"
          useFlexGap
          flexWrap="wrap"
          justifyContent="center"
        >
          {ingredients.map((ingredient, i) => {
            return (
              <Chip
                key={i}
                style={{ flexGrow: 1 }}
                label={ingredient}
                variant={i % 2 === 0 ? "filled" : "outlined"}
              />
            );
          })}
        </Stack>
      </div>
      <h3>Rezeptidee</h3>
      {recepieExample}
    </>
  );
};
